namespace Ir.Components.Workbook.Settings.GaugeSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<number>;
        itemConfig: BaseItemConfig;

        metricParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        targetParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        formattingRuleParams: Ir.Components.Workbook.Settings.Items.FormattingRuleSetting.IFormattingRuleSettingParams;

        endValueOptions: DevExpress.ui.dxNumberBox.Properties;
        typeOptions: DevExpress.ui.dxSelectBox.Properties;
        showIndicatorValueOptions: DevExpress.ui.dxSelectBox.Properties;
        sizeOptions: DevExpress.ui.dxNumberBox.Properties;
        showTickOptions: DevExpress.ui.dxSwitch.Properties;
        tickIntervalTypeOptions: DevExpress.ui.dxSelectBox.Properties;
        tickIntervalValueOptions: DevExpress.ui.dxNumberBox.Properties;
        formatOptions: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingParams;

        indicatorFormatDecimalPlacesOptions: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        indicatorFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        indicatorUnitFormatOptions: Ir.Components.Workbook.Settings.Items.UnitFormatSetting.IUnitFormatSettingParams;

        scalesFormatDecimalPlacesOptions: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        scalesFontSizeOptions: Ir.Components.Workbook.Settings.Items.FontSizeSetting.IFontSizeSettingParams;
        scalesUnitFormatOptions: Ir.Components.Workbook.Settings.Items.UnitFormatSetting.IUnitFormatSettingParams;
        scalesPositionOptions: DevExpress.ui.dxSelectBox.Properties;
        
        accountingStyleOptions: DevExpress.ui.dxSelectBox.Properties;

        comparisonFilterParams: Ir.Components.Workbook.Settings.Items.ComparisonFilterSetting.IComparisonFilterSettingParams;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        this.config = params.config as WorkbookConfig;
        this.activeTabOrWidget = params.activeTabOrWidget;
        this.activeTabItem = params.activeTabItem;
        this.itemConfig = this.activeTabOrWidget().itemConfig();
        let config = this.itemConfig as GaugeConfig;
        let mapWidget = this.activeTabOrWidget().widget.getWidget<GaugeWidget>() as GaugeWidget;
        let self = this;

        this.metricParams = {
            label: "Metric",
            type: MappingPopoverTypeEnum.Metrics,
            id: config.metric,
            valueChangeType: FieldMetricSettingsValueChangeTypeEnum.After,
            onSelected(newValue: FieldNameInputModel, oldValue: FieldNameInputModel) {
                //If the metric is the same of target because of the comparison filter, update the target metric too
                if ((!config.target() || (oldValue && config.target() === oldValue.metricId)) && config.comparisonFilter.dateOption() !== ComparisonDateOptionEnum.Manual) {
                    config.target(newValue.metricId);
                }

                config.endValue(null);

                mapWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            },
            onClear() {
                config.endValue(null);
                config.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);

                mapWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            }
        };

        this.targetParams = {
            label: "Target",
            type: MappingPopoverTypeEnum.Metrics,
            id: config.target,
            valueChangeType: FieldMetricSettingsValueChangeTypeEnum.After,
            onSelected(newValue: FieldNameInputModel, oldValue: FieldNameInputModel) {
                if (newValue.metricId !== config.metric())
                    config.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);

                mapWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            },
            onClear() {
                config.comparisonFilter.dateOption(ComparisonDateOptionEnum.Manual);

                mapWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            }
        };

        this.formattingRuleParams = {
            label: "Formatting Rule",
            id: config.formattingRule
        }

        this.comparisonFilterParams = {
            label: "Target Comparison Filter",
            manualText: "None",
            comparisonFilter: config.comparisonFilter,
            onValueChanged() {
                mapWidget.saveSettings(function () {
                    self.activeTabOrWidget().refresh();
                });
            }
        }

        this.endValueOptions = {
            format: '0#',
            value: config.endValue as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            width: 80
        };
        this.typeOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: config.type,
            items: [
                { id: GaugeTypeEnum.Bar, text: 'Bar' },
                { id: GaugeTypeEnum.Circular, text: 'Circular' }
            ]
        };
        this.showIndicatorValueOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: config.showIndicatorValue,
            items: [
                { id: GaugeShowIndicatorValueEnum.None, text: 'None' },
                { id: GaugeShowIndicatorValueEnum.Middle, text: 'Middle' }
            ],
            width: 90
        };
        this.sizeOptions = {
            format: '0#',
            value: config.size as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 10,
            max: 200,
            width: 80
        };
        this.showTickOptions = {
            value: config.tick as any
        };
        this.tickIntervalTypeOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: config.tickIntervalType,
            items: [
                { id: GaugeTickIntervalTypeEnum.Percentual, text: 'Percentual' },
                { id: GaugeTickIntervalTypeEnum.Value, text: 'Value' }
            ],
            width: 110
        };
        this.tickIntervalValueOptions = {
            format: '0#',
            value: config.tickIntervalValue as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 1,
            width: 80
        };
        this.formatOptions = {
            value: config.format
        };

        this.indicatorFormatDecimalPlacesOptions = {
            value: config.indicatorFormat.decimalPlaces
        };
        this.indicatorFontSizeOptions = {
            value: config.fontSize
        };
        this.indicatorUnitFormatOptions = {
            value: config.indicatorFormat.unitFormat
        };

        this.scalesFormatDecimalPlacesOptions = {
            value: config.scalesFormat.decimalPlaces
        };
        this.scalesFontSizeOptions = {
            label: "Label Font Size",
            value: config.scalesFormat.labelFontSize
        };
        this.scalesUnitFormatOptions = {
            value: config.scalesFormat.unitFormat
        };
        this.scalesPositionOptions = {
            displayExpr: 'text',
            valueExpr: 'value',
            value: config.scalesFormat.position,
            items: [
                { value: GaugeScalePositionEnum.Inside, text: 'Inside' },
                { value: GaugeScalePositionEnum.Outside, text: 'Outside' }
            ],
            width: 117
        };

        this.accountingStyleOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: config.accountingStyle,
            items: [
                { id: -1, text: 'Based on Metric' },
                { id: 0, text: 'False' },
                { id: 1, text: 'True' }
            ],
            width: 117
        };
    }
}